import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { BotMessage } from "./BotMessage";
import { UserTextmessage } from "./UserMessage";
dayjs.extend(duration);

export const Chats = ({ messages }) => {
	let i = 0;
	let tempMessages = [];
	let messageCount = messages.length;

	while (i < messageCount) {
		let previous = messages[i - 1];
		let current = messages[i];
		let next = messages[i + 1];
		let isUser = current.sender === "USER";
		const ts = current.ts;
		let currentMoment = dayjs(ts);
		let prevBySameAuthor = false;
		let nextBySameAuthor = false;
		let startsSequence = true;
		let endsSequence = true;
		let showTimestamp = true;

		if (previous) {
			let previousMoment = dayjs(previous.ts);
			let previousDuration = dayjs.duration(
				currentMoment.diff(previousMoment)
			);
			prevBySameAuthor = previous.sender === current.sender;

			if (prevBySameAuthor && previousDuration.as("seconds") < 5) {
				startsSequence = false;
			}

			if (previousDuration.as("seconds") < 5) {
				showTimestamp = false;
			}
		}
		if (next) {
			let nextMoment = dayjs(next.ts);
			let nextDuration = dayjs.duration(nextMoment.diff(currentMoment));
			nextBySameAuthor = next.sender === current.sender;

			if (nextBySameAuthor && nextDuration.as("seconds") < 5) {
				endsSequence = false;
			}
		}
		if (isUser) {
			tempMessages.push(
				<UserTextmessage messageItem={current} key={i} />
			);
		} else {
			tempMessages.push(
				<BotMessage
					messageItem={current}
					key={i}
					index={i}
					startsSequence={startsSequence}
					endsSequence={endsSequence}
					showTimestamp={showTimestamp}
					ts={ts}
				/>
			);
		}
		i += 1;
	}
	return tempMessages;
};
